
import Vue from "vue";
import SammanstallningField from "./SammanstallningField.vue";
import { VetPersonnummer, VilkenRoll } from "@/store/types";
import { mapFields } from "vuex-map-fields";

export default Vue.extend({
    name: "PrivatpersonSammanstallning",
    components: {
        SammanstallningField,
    },
    data: () => ({
        VetPersonnummer,
        VilkenRoll,
    }),
    computed: {
        ...mapFields([
            "forsteg.vilkenroll",
            "kontaktuppgifter.anmaldFornamn",
            "kontaktuppgifter.anmaldEfternamn",
            "kontaktuppgifter.anmaldPersonnummer",
            "kontaktuppgifter.anmaldKontaktuppgift",
            "kontaktuppgifter.vetPersonnummer",
            "kontaktuppgifter.anmaldFodelsedatum",
            "kontaktuppgifter.anmaldAdressOrt",
            "kontaktuppgifter.anmaldAndraUppgifter",
        ]),
    },
});
